import { render, staticRenderFns } from "./train_add.vue?vue&type=template&id=e5ffb1c8&"
import script from "./train_add.vue?vue&type=script&lang=ts&"
export * from "./train_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports